// --------------------------------------------------
// data flask locations

// live location = "https://domain.com/prod/";
// test location = "https://domain.com/dev/";

export const ENDPOINT = "https://domain.com/prod/";